/* eslint-disable @typescript-eslint/no-unsafe-return */

const _componentAliases = [
  'ColumnBannerBlock',
  'PersonBlock',
  'ReadmoreContentBlock',
  'RowBlock',
  'RowContentBlock',
  'ContentArea',
  'RichTextBlock',
  'string',
];

type ComponentAlias = (typeof _componentAliases)[number];

const componentMap = {
  ColumnBannerBlock: async () => import('@werkenbij/components/blocks/ColumnBannerBlock.vue'),
  PersonBlock: async () => import('@werkenbij/components/blocks/PersonBlock.vue'),
  ReadmoreContentBlock: async () => import('@werkenbij/components/blocks/ReadMoreBlock.vue'),
  RowBlock: async () => import('@werkenbij/components/blocks/RowBlock.vue'),
  RowContentBlock: async () => import('@werkenbij/components/blocks/RowContentBlock.vue'),
  ContentArea: async () => import('@werkenbij/components/blocks/WerkenbijContentArea.vue'),
  RichTextBlock: async () => import('@werkenbij/components/blocks/WerkenbijContentArea.vue'),
  string: async () => import('@base/components/richtext/RichText.vue'),
} as const;

export function useWerkenbijCompMapper(): UseComponentMapper<ComponentAlias> {
  return useComponentMapper<ComponentAlias>(componentMap);
}
